module.exports = __webpack_public_path__ + "static/media/meme.49215541.png";